import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { PricingPlan } from "@/model/interface/PricingPlan";
import React from "react";

interface PlanIdentitySectionProps {
  editing: Partial<PricingPlan>;
  onField: (field: string, value: unknown) => void;
}

export default function PlanIdentitySection({ editing, onField }: PlanIdentitySectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Identity</CardTitle>
        <CardDescription>Plan name, default flag, and partner billing overrides.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5">
            <Label>Name</Label>
            <Input
              value={editing.name ?? ""}
              onChange={(changeEvent) => onField("name", changeEvent.target.value)}
              placeholder="Default"
            />
          </div>
          <div className="flex items-center gap-4 pt-6">
            <div className="flex items-center gap-2">
              <Label>Default</Label>
              <Switch
                checked={editing.isDefault}
                onCheckedChange={(isDefault) => onField("isDefault", isDefault)}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5">
            <Label className="text-xs">
              Per-seat price override ($)
              <span className="text-muted-foreground"> (empty = use subscription plan)</span>
            </Label>
            <Input
              type="number"
              step="0.01"
              value={editing.perSeatMonthlyPriceOverride ?? ""}
              onChange={(changeEvent) =>
                onField(
                  "perSeatMonthlyPriceOverride",
                  changeEvent.target.value ? parseFloat(changeEvent.target.value) : null,
                )
              }
              placeholder="From subscription"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Partner Stripe Price ID</Label>
            <Input
              value={editing.partnerStripePriceId ?? ""}
              onChange={(changeEvent) => onField("partnerStripePriceId", changeEvent.target.value || null)}
              placeholder="price_..."
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
